<template>
    <div class="container">
        <div v-if="cuIconList.length > 0" class="grid-wrapper">
            <div class="cu-list grid" :class="['col-' + gridCol,gridBorder?'':'no-border']">
                <div class="cu-item" v-for="(item,index) in cuIconList" :key="index" @click="gridClick(item, index)">
                    <div class="image-box">
                        <img :src="item.img" />
                    </div>
                    <span>{{item.name}}</span>
                </div>
            </div>
            <button class="gridBtn" @click="btnClick">{{btnTxt}} ></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cuIconList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        btnObj: {
            type: String,
            default: ''
        },
        parentObj: {
            type: Object,
            default: function () {
                return {};
            }
        },
        btnTxt: {
            type: String,
            default: '查看全部'
        },
        gridCol: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            gridBorder: false
        };
    },
    methods: {
        gridClick(item, index) {
            this.$emit('gridClick', item, index, this.parentObj);
        },
        btnClick() {
            this.$emit('gridBtnClick');
        }

    }
};
</script>

<style lang="scss" scoped>
.container {
    border-radius: 15px;
    overflow: hidden;

    .grid-wrapper {
        background: #fff;
        padding: 10px 0;
    }

    .cu-list {
        display: flex;
        flex-wrap: wrap;
    }

    .cu-item {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 33.3%;

        .image-box {
            width: 62px;
            height: 62px;
            margin-bottom: 6px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .gridBtn {
        margin: 15px 30px 0;
        background: #FFF6F8;
        color: #ee2e50;
        border: none;
        font-size: 14px;
        width: 90%;
        padding: 10px 0;
        display: block;
        margin: 0 auto;
        margin-top: 15px;
        margin-bottom: 5px;
    }

    .gridBtn:after {
        border: none;
    }
}
</style>
